// extracted by mini-css-extract-plugin
module.exports = {"capability-set":"ManagedProductSettings_capability-set__kTJ0T"};